import { render, staticRenderFns } from "./DuplicateWorkflowDialog.vue?vue&type=template&id=f8e1503a&scoped=true&"
import script from "./DuplicateWorkflowDialog.vue?vue&type=script&lang=ts&"
export * from "./DuplicateWorkflowDialog.vue?vue&type=script&lang=ts&"
import style0 from "./DuplicateWorkflowDialog.vue?vue&type=style&index=0&id=f8e1503a&prod&lang=scss&module=true&"
import style1 from "./DuplicateWorkflowDialog.vue?vue&type=style&index=1&id=f8e1503a&prod&lang=scss&scoped=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "f8e1503a",
  null
  
)

export default component.exports